<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <!-- <div class="margin b15">
        <el-row :gutter="20" class="margin b15">

          <el-col :span="4">
            <el-button icon=""
                       type="primary"
                       @click="showCustomerInvoiceUploadDialog"
                       size="small">批量更新开票信息
            </el-button>
          </el-col>
        </el-row>
      </div> -->

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="50"></el-table-column>
        <el-table-column prop="display_name"
                         label="名称"
                         min-width="120">
          <template slot-scope="scope">
            <span style="cursor:pointer;color:rgb(88,157,248)"
                  @click="onDownSourceFile(scope.row)">{{scope.row.display_name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="admin_name"
                         label="发起者"
                         min-width="120"></el-table-column>
        <el-table-column prop="created_at"
                         label="上传时间"
                         min-width="120"></el-table-column>
        <el-table-column label="任务进度"
                         min-width="120">
          <template slot-scope="scope">
            <sj-progress :text-inside="true"
                         :stroke-width="18"
                         :status="taskBatchStatus(scope.row)"
                         :percentages="taskBatchPercentage(scope.row)"></sj-progress>
            成功:{{scope.row.success_count}} 错误:{{scope.row.error_count}}
          </template>
        </el-table-column>
        <el-table-column prop="task_type"
                         label="类型"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in options.batch_type"
                  v-if="scope.row.task_type === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in status"
                  v-if="scope.row.status === item.value">{{item.label}}</span>
            <span v-if="scope.row.status === -2 && scope.row.error_message">{{scope.row.error_message}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope" v-if="isThisMyJob(scope.row)">
            <span v-if="(scope.row.status === 3 && scope.row.error_count > 0)">
              <el-button type="text"
                         size="mini"
                         @click="onDownErrorFile(scope.row.id)">下载错误行</el-button>
            </span>
            <span v-if="scope.row.status === -1">
              <el-button type="text"
                         size="mini"
                         @click="onDownExportFile(scope.row.id)">下载未处理行</el-button>
            </span>
            <span v-if="(scope.row.status === 1 || scope.row.status === 2) && scope.row.file_type === 6">
              <el-button type="text"
                         size="mini"
                         @click="onCancelTaskBatch(scope.row.id)">取消</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <customer-batch-invoice-upload-dialog :visible="uploadDialogVisible"
                          @closeDialog="closeCustomerInvoiceUploadDialog">
    </customer-batch-invoice-upload-dialog>

  </div>
</template>

<script>
import table from '@core/mixins/table'
import downloadJS from 'downloadjs'
import SjProgress from '@/components/sj-progress'
import taskBatchMixins from '@/views/task-batch/task-batch.mixins'
import customerMixins from '../customer.mixins'
import CustomerBatchInvoiceUploadDialog from '@views/customer/components/CustomerBatchInvoiceUploadDialog'

export default {
  mixins: [table, taskBatchMixins, customerMixins],
  components: {SjProgress, CustomerBatchInvoiceUploadDialog},
  name: 'CustomerBatchTable',
  data () {
    return {
      options: {
        batch_type: [
          // 客户的批量类型
          {value: 235, label: '批量更新开票信息'},
          {value: 240, label: '批量增加客户批次'},
        ],
      },
      search: {
        task_type: [235, 240],
      },
      uploadDialogVisible: false,
    }
  },
  computed: Vuex.mapState({
    status: state => state.taskBatch.status,
    users: state => state.login.user,
  }),
  created () {
  },
  methods: {
    ...Vuex.mapActions([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.common('queryBatchUpload', params)
    },
    isThisMyJob (row) {
      if (this.users.usertype * 1 === 1) {
        return true
      }
      return row.admin_id + '' === this.users.id + ''
    },
    onDownSourceFile (row) {
      if (!this.isThisMyJob(row)) {
        this.$message.error('仅允许下载自己发起的任务或上传的文件')
        return
      }
      downloadJS(request.items.downSourceFile(row.id))
    },
    onDownErrorFile (id) {
      downloadJS(request.items.downErrorFile(id))
    },
    onDownExportFile (id) {
      downloadJS(request.items.downExportFile(id))
    },
    onCancelTaskBatch (id) {
      request.page('cancelTaskBatch', {id: id}).then(({data}) => {
        this.$message('取消批量任务(' + id + ')成功')
        this.onSearch()
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/customer/pages/CustomerBatchTable.vue